import { Injectable } from '@angular/core'
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpParams
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CustomParameterInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> { // NOSONAR
        const fgaDetails :any  = JSON.parse(sessionStorage.getItem('FGA'))
        const upn = fgaDetails?.user?.userPrincipalName
        if (upn && upn != undefined) { // NOSONAR
            const modifiedParams = req.params.set('userId', upn);


            let modifiedReq = req;
            if (req.method == 'POST' || req.method == 'PUT') { // NOSONAR

                if (req.body && !(req.body instanceof ArrayBuffer) && !(req.body instanceof Blob) && !(req.body instanceof File)) {
                    const originalBody = req.body || {};
                    const searchCriteriaMap = originalBody.searchCriteriaMap
                        ? { ...originalBody.searchCriteriaMap, userId: upn }
                        : undefined; 

                    const newBody = {
                        ...originalBody,
                        ...(searchCriteriaMap ? { searchCriteriaMap } : {}) 
                    };

                    modifiedReq = req.clone({ body: newBody });
                }
                if ((req.body instanceof FormData) || (req.body instanceof File) || (req.body instanceof Blob) || (req.body instanceof ArrayBuffer)) {
                    
                    return next.handle(req);
                }

            } else if(req.method == 'GET')  { // NOSONAR
                modifiedReq = req.clone({ params: modifiedParams });
            }
            
            

            return next.handle(modifiedReq);
        }
    }
}